function getEnPrioritizedText(text) {
    const locales = Object.keys(text).sort();
    for (const locale of locales){
        if (locale.toLocaleLowerCase().startsWith('en')) {
            var _locale;
            return (_locale = text[locale]) !== null && _locale !== void 0 ? _locale : '';
        }
    }
    const fallback = locales[0] ? text[locales[0]] : '';
    return fallback !== null && fallback !== void 0 ? fallback : '';
}

export { getEnPrioritizedText };
//# sourceMappingURL=utils.js.map
